import { FunctionComponent, useEffect } from 'react';
import { useAppendToAntiSharingTracking } from '@tv2/lib-offspring/hooks/tracking/useAppendToTracking';
import { ClientUser } from '@tv2/lib-api/src/ClientUser';
import { QueryClientProvider } from '@tv2/lib-offspring/api/graphql/QueryClientProvider';
import { getPublicRuntimeEnv } from '@tv2/lib-offspring/libs/publicEnv';
import useAntiSharingPolling from '../hooks/usePolling';

const env = getPublicRuntimeEnv();

export const AntiSharingPolling: FunctionComponent<{ user: ClientUser }> = () => {
  const [access, initializing, ___, __] = useAntiSharingPolling(false);
  const setAntiSharingTracking = useAppendToAntiSharingTracking();

  useEffect(() => {
    if (!initializing && access?.appendToTracking) {
      setAntiSharingTracking(access.appendToTracking);
    }
  }, [initializing, access?.appendToTracking, setAntiSharingTracking]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAntiSharingTracking({});
    }, 500);
    return () => clearTimeout(timeout);
  }, [setAntiSharingTracking]);

  return null;
};

export const AntiSharing: FunctionComponent<{ user: ClientUser }> = ({ user }) => {
  return (
    <QueryClientProvider apiUrl={env.ANTI_SHARING_URL} isAdmin={false}>
      <AntiSharingPolling user={user} />
    </QueryClientProvider>
  );
};
